import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import { getUser } from '../../../../actions/session';
import { SERVER_CREATED } from '../../../../config/rest_endpoints';
import { Notifications } from '../../../common/notification';


class AddServer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            ip: '',
            techPrefix:'',
            port:'5060',
            mask: '32',
            enforceOverRide: false,
            switched: true,
            userId: this.props.accountID,
            msg: '',
            isLoad:false
        }
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.toggleSwitchEnforce = this.toggleSwitchEnforce.bind(this)
    }

    onHandleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    clearForm() {
        this.setState({
            ip: '',
            switched: true,
        })
    }

    onSubmitChange() {
        const {ip, port, techPrefix, enforceOverRide, switched, User, userId,mask } = this.state
        const serverPlayload = {
            'ip': ip,
            'port': parseInt(port),
            'techPrefix' : techPrefix,
            'mask':parseInt(mask),
            'enforceOverRide': enforceOverRide,
            'enabled': switched
        }
        this.setState({isLoad:true})
        var headers = { "Authorization": "Bearer " + User.token };
        if ( ip == '') {
            console.log('fill form');
            Notifications.notify("One of form field is empty", "Error", "error")
            this.setState({isLoad:false})

        }
        else if (port == '') {
            Notifications.notify("One of form field is empty", "Error", "error")
            this.setState({isLoad:false})
        }
        else {
            axios.post(`${SERVER_CREATED}/${userId}/server/create`, serverPlayload, { headers }).then(res => {
                if (res) {
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    this.props.close()
                    this.props.listingServer()
                    this.clearForm()
                    Notifications.notify(this.state.msg, "Created", "success")
                }
                else {
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    Notifications.notify(this.state.msg, "error", "error")
                }
            }).catch(err => {
                var msessage = err.response.data.message
                console.log(`msessage`, msessage)
                Notifications.notify(msessage, "Failed", "error")
                this.setState({
                    isLoad:false
                })
            })
        }
    }

    toggleSwitchEnforce() {
        this.setState({ enforceOverRide: !this.state.enforceOverRide })
    }

    render() {
        const {ip, port,  techPrefix, enforceOverRide,switched,mask } = this.state
        console.log('port',port)

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        const switchRowStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 14px',
            background: '#F8FAFC',
            borderRadius: '10px',
            border: '1px solid #E2E8F0',
            marginBottom: '12px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Source IP</label>
                            <input type="text" className="form-control" name="ip" value={ip} onChange={this.onHandleChange} placeholder="Enter server ip" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Tech Prefix</label>
                            <input type="text" className="form-control" name="techPrefix" value={techPrefix} onChange={this.onHandleChange} placeholder="Enter tech prefix" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Mask</label>
                            <input type="number" className="form-control" name="mask" value={mask} onChange={this.onHandleChange} placeholder="Enter mask" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Port</label>
                            <input type="number" className="form-control" name="port" value={port} onChange={this.onHandleChange} placeholder="Enter port" />
                        </div>
                    </div>
                </div>
                <div style={switchRowStyle}>
                    <span style={{fontSize:'13px',fontWeight:'500',color:'#475569'}}>Enabled</span>
                    <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                </div>
                <div style={switchRowStyle}>
                    <span style={{fontSize:'13px',fontWeight:'500',color:'#475569'}}>Enforce Override</span>
                    <Switch onChange={this.toggleSwitchEnforce} checked={enforceOverRide} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        disabled={this.state.isLoad}
                        onClick={this.onSubmitChange}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Add
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-file-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default AddServer